import { render, staticRenderFns } from "./correction.vue?vue&type=template&id=24e84cd6&scoped=true"
import script from "./correction.vue?vue&type=script&lang=js"
export * from "./correction.vue?vue&type=script&lang=js"
import style0 from "./correction.vue?vue&type=style&index=0&id=24e84cd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e84cd6",
  null
  
)

export default component.exports